var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header-logo-container",
      on: {
        click: function($event) {
          return _vm.handleImageClick()
        }
      }
    },
    [
      _c("img", {
        attrs: {
          alt: _vm.getStoreName + " image",
          src: require("../../../assets/store-logo.png")
        },
        on: { load: _vm.logoLoaded }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d0c6f46", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d0c6f46","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/NavigationItems/HeaderLogo.vue
// module id = null
// module chunks = 